/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Jobs_Last_ScrapedInputs */

const en_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last scraped: ${i?.date}`)
};

const de_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt gescrapt: ${i?.date}`)
};

const fr_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière récupération : ${i?.date}`)
};

const es_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última recopilación: ${i?.date}`)
};

const it_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima ricerca: ${i?.date}`)
};

const nl_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laatst gezocht: ${i?.date}`)
};

const pl_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ostatnie wyszukiwanie: ${i?.date}`)
};

const fi_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Viimeksi haettu: ${i?.date}`)
};

const da_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sidst skrabet: ${i?.date}`)
};

const sv_jobs_last_scraped = /** @type {(inputs: Jobs_Last_ScrapedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Senast skrapad: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last scraped: {date}" |
*
* @param {Jobs_Last_ScrapedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_last_scraped = /** @type {((inputs: Jobs_Last_ScrapedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Last_ScrapedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_last_scraped(inputs)
	if (locale === "fr") return fr_jobs_last_scraped(inputs)
	if (locale === "es") return es_jobs_last_scraped(inputs)
	if (locale === "it") return it_jobs_last_scraped(inputs)
	if (locale === "nl") return nl_jobs_last_scraped(inputs)
	if (locale === "pl") return pl_jobs_last_scraped(inputs)
	if (locale === "fi") return fi_jobs_last_scraped(inputs)
	if (locale === "da") return da_jobs_last_scraped(inputs)
	if (locale === "sv") return sv_jobs_last_scraped(inputs)
	return en_jobs_last_scraped(inputs)
});